import { RoomAtoms } from './atoms';

export * from './atoms';



export const RoomComponents = [
    ...RoomAtoms
]